// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-20 {
  padding: 1.25rem;
}

.padding-5 {
  padding: 0.3rem !important;
}

.padding-10 {
  padding: 0.625rem;
}

.changetable td:first-child {
  background-color: #edf4fa;
}
.changetable th {
  background-color: #edf4fa !important;
  color: #595959;
}
.changetable td {
  width: 15rem;
  max-width: 15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-left {
  text-align: left;
}

.float-left {
  float: left;
}

.margin-l-20 {
  margin-left: 1.25rem;
}

.artworkchangeheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem;
}

.flag-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.artworkchangebread {
  font-size: 1rem;
  font-weight: 900;
  line-height: 1;
  color: #003da5;
  text-decoration: none;
}

.flag-content {
  margin-left: 70px;
  display: flex;
  align-items: center;
}
.flag-content span {
  margin-left: 0.3rem;
}

.changesTable {
  padding: 1.25rem;
  overflow: auto;
  height: 25rem;
  border-color: #acacac;
  border-style: solid;
  border-width: 0.5px;
  border-radius: 8px;
  margin-top: 10px;
}

.field-details, .popfield {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.6rem;
}
.field-details > div, .popfield > div {
  width: calc(33.33% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footercheck {
  margin-left: 0.8rem;
}

.greenIcon {
  color: #03a000;
  font-size: 1rem;
}

.redIcon {
  color: #ff0000;
  font-size: 1rem;
}

.grayIcon {
  color: #9a9898;
  font-size: 1rem;
}

.margin-left-10 {
  margin-left: 0.625rem;
}

.newvalue {
  color: #ff0000 !important;
}

.changefooter {
  background: #fafafa;
  padding: 0.625rem !important;
}

.updates {
  overflow: auto;
  height: 12.5rem;
}
.updates .updatesData {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.p-tooltip.p-tooltip-top.tooltip-white-footer {
  padding: 0.2em 0;
  margin-left: 3.1rem;
  margin-top: -0.188rem;
}
.p-tooltip.p-tooltip-top.tooltip-white-footer.grey-out-tooltip {
  padding: 0.2em 0;
  margin-top: -1.25rem;
  margin-left: 12.59rem;
}
.p-tooltip.p-tooltip-top.tooltip-white-footer.grey-out-tooltip .p-tooltip-text {
  display: flex;
  color: black;
  width: 16.375rem;
  font-size: 0.75rem;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white;
  border: 1px solid #fff7f7;
}
.p-tooltip.p-tooltip-top.tooltip-white-footer .p-tooltip-text {
  width: 100%;
  display: flex;
  color: black;
  font-size: 0.8rem;
  text-align: left;
  align-items: center;
  white-space: pre-line;
  word-break: break-word;
  justify-content: center;
  background-color: white;
  border: 1px solid #fff7f7;
}
.p-tooltip.p-tooltip-top.tooltip-white-footer .p-tooltip-text ::after {
  left: 50%;
  top: 100%;
  content: "";
  position: absolute;
  border-style: solid;
  margin-left: -0.625rem;
  border-width: 0.625rem;
  border-color: black transparent transparent transparent;
}
.p-tooltip.p-tooltip-top.tooltip-white-footer .p-tooltip-arrow {
  content: "";
  top: 87%;
  left: 60%;
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  margin-left: -0.313rem;
  border-color: white transparent transparent transparent;
}

.poaconfirmpopup {
  width: 70%;
}

.changeNotification .project-name {
  padding: 0.3rem;
}

.margin-t-10 {
  margin-top: 0.6rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ChangeNotification/index.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAOE;EACE,yBAAA;AAJJ;AAME;EACE,oCAAA;EACA,cAAA;AAJJ;AAME;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AALF;;AAQA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;AALF;;AAQA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AALF;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AALF;AAOE;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALJ;;AASA;EACE,mBAAA;AANF;;AASA;EACE,cAzGY;EA0GZ,eAAA;AANF;;AASA;EACE,cA/GU;EAgHV,eAAA;AANF;;AASA;EACE,cAlHW;EAmHX,eAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,mBAAA;EACA,4BAAA;AANF;;AAQA;EACE,cAAA;EACA,eAAA;AALF;AAME;EACE,kBAAA;EACA,qBAAA;AAJJ;;AAOA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AAJF;AAKE;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;AAHJ;AAII;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AAFN;AAME;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;AAJJ;AAKI;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uDAAA;AAHN;AAOE;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uDAAA;AALJ;;AAQA;EACE,UAAA;AALF;;AAQE;EACE,eAAA;AALJ;;AAQA;EACE,kBAAA;AALF","sourcesContent":["$color-red: #ff0000;\n$color-green: #03a000;\n$color-gray: #9a9898;\n\n.padding-20 {\n  padding: 1.25rem;\n}\n\n.padding-5 {\n  padding: 0.3rem !important;\n}\n\n.padding-10 {\n  padding: 0.625rem;\n}\n\n.changetable {\n  td:first-child {\n    background-color: #edf4fa;\n  }\n  th {\n    background-color: #edf4fa !important;\n    color: #595959;\n  }\n  td {\n    width: 15rem;\n    max-width: 15rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.text-left {\n  text-align: left;\n}\n\n.float-left {\n  float: left;\n}\n\n.margin-l-20 {\n  margin-left: 1.25rem;\n}\n\n.artworkchangeheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.3rem;\n}\n\n.flag-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.artworkchangebread {\n  font-size: 1rem;\n  font-weight: 900;\n  line-height: 1;\n  color: #003da5;\n  text-decoration: none;\n}\n\n.flag-content {\n  margin-left: 70px;\n  display: flex;\n  align-items: center;\n\n  span {\n    margin-left: 0.3rem;\n  }\n}\n\n.changesTable {\n  padding: 1.25rem;\n  overflow: auto;\n  height: 25rem;\n  border-color: #acacac;\n  border-style: solid;\n  border-width: 0.5px;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n.field-details, .popfield {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 0.6rem;\n\n  > div {\n    width: calc(33.33% - 10px);\n    margin-right: 10px;\n    margin-bottom: 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.footercheck {\n  margin-left: 0.8rem;\n}\n\n.greenIcon {\n  color: $color-green;\n  font-size: 1rem;\n}\n\n.redIcon {\n  color: $color-red;\n  font-size: 1rem;\n}\n\n.grayIcon {\n  color: $color-gray;\n  font-size: 1rem;\n}\n\n.margin-left-10 {\n  margin-left: 0.625rem;\n}\n\n.newvalue {\n  color: $color-red !important;\n}\n\n.changefooter {\n  background: #fafafa;\n  padding: 0.625rem !important;\n}\n.updates {\n  overflow: auto;\n  height: 12.5rem;\n  .updatesData {\n    margin-top: 0.3rem;\n    margin-bottom: 0.3rem;\n  }\n}\n.p-tooltip.p-tooltip-top.tooltip-white-footer {\n  padding: 0.2em 0;\n  margin-left: 3.1rem;\n  margin-top: -0.188rem;\n  &.grey-out-tooltip {\n    padding: 0.2em 0;\n    margin-top: -1.25rem;\n    margin-left: 12.59rem;\n    .p-tooltip-text {\n      display: flex;\n      color: black;\n      width: 16.375rem;\n      font-size: 0.75rem;\n      text-align: left;\n      align-items: center;\n      white-space: pre-line;\n      word-break: break-word;\n      justify-content: center;\n      background-color: white;\n      border: 1px solid #fff7f7;\n    }\n  }\n\n  .p-tooltip-text {\n    width: 100%;\n    display: flex;\n    color: black;\n    font-size: 0.8rem;\n    text-align: left;\n    align-items: center;\n    white-space: pre-line;\n    word-break: break-word;\n    justify-content: center;\n    background-color: white;\n    border: 1px solid #fff7f7;\n    ::after {\n      left: 50%;\n      top: 100%;\n      content: '';\n      position: absolute;\n      border-style: solid;\n      margin-left: -0.625rem;\n      border-width: 0.625rem;\n      border-color: black transparent transparent transparent;\n    }\n  }\n\n  .p-tooltip-arrow {\n    content: '';\n    top: 87%;\n    left: 60%;\n    position: absolute;\n    border-width: 1rem;\n    border-style: solid;\n    margin-left: -0.313rem;\n    border-color: white transparent transparent transparent;\n  }\n}\n.poaconfirmpopup{\n  width: 70%;\n}\n.changeNotification{\n  .project-name{\n    padding: 0.3rem;\n  }\n}\n.margin-t-10{\n  margin-top: 0.6rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
